<template>
	<li :class="`auctionListItem--type-${auction.type} ${colorClass}`">
		<div :class="`auctionItem d-flex auctionItem--type-${auction.type} ${colorClass}`">
			<div v-if="auction.type === 'LOWEST_UNIQUE'" class="badge-LOWEST_UNIQUE">
				{{ $t('home.auction_item_badge_lowest_unique') }}
			</div>
			<div v-else-if="auction.maxPrice" class="badge-MAX_BID">
				{{ $t('home.auction_item_max_info') }}
			</div>
			<div class="auctionItem_leftSide">
				<div class="auctionItem_statusBar">
					<div v-if="auction.status != 'FINISHED'">
						<i class="fas fa-clock"></i> {{ lockTime }}
						<span>{{ $t('home.auction_item_timer_title_' + auction.status) }}</span>
					</div>
				</div>
				<template v-if="auction.photoUrls && auction.photoUrls.length > 0">
					<img
						@click="
							openInfoPopup()
							btnSfx()
						"
						:src="auction.photoUrls[viewImage]"
					/>
					<a href="#" @click.prevent="viewImage - 1 >= 0 ? --viewImage : (viewImage = 0)"><i class="fas fa-chevron-circle-left"></i></a>
					<a href="#" @click.prevent="viewImage + 1 < auction.photoUrls.length - 1 ? viewImage++ : (viewImage = auction.photoUrls.length - 1)"
						><i class="fas fa-chevron-circle-right"></i
					></a>
				</template>
			</div>
			<div class="auctionItem_rightSide">
				<h5
					@click="
						onPublicAuctionClick();
						btnSfx()
					"
				>
					{{ auction.name }}
				</h5>
				<div
					@click="
						onPublicAuctionClick()
						btnSfx()
					"
					class="auctionItem_info"
				>
					{{ $t('home.auction_item_label_info') }}
					<a href="#">{{ $t('home.auction_item_label_view_more') }} <i class="fas fa-chevron-right"></i></a>
				</div>
				<p>
					{{ auction.description.length > 150 ? auction.description.substring(0, 150) + '...' : auction.description }}
				</p>

				<div v-if="auction.type === 'STANDARD'" class="auctionItem_startBid">
					<h4>{{ $t('home.auction_item_label_offer_start') }}</h4>
					<b>{{ auction.startPrice.toLocaleString('sr-RS') }}</b>
					<img class="diamond" :src="auction?.mtsCustomerCategory ? '/images/rubins.png' : '/images/diamond.png'" />
				</div>
				<div v-if="auction.maxPrice" @click="openMaxPriceInfoPopup" class="auctionItem_maxBid">
					<span
						v-html="
							$t('home.auction_item_max_price', {
								max_price: auction.maxPrice.toLocaleString('sr-RS'),
							})
						"
					></span>
					<img class="diamond" :src="auction?.mtsCustomerCategory ? '/images/rubins.png' : '/images/diamond.png'" />
				</div>
			</div>
		</div>
		<div v-if="auction.status === 'PENDING'" class="auctionItem_actions">
			<p class="mb-1">{{ $t('home.auction_item_bottom_info_panding') }}</p>
			<h4 class="font-weight-bold text-danger">
				{{ lockTime }}
			</h4>
		</div>
		
		<div class="auctionItem_actions">
			<b-button
				@click="
					onPublicAuctionClick();
					btnSfx()
				"
				variant="primary"
				size="lg"
				>{{ $t('home.auction_item_btn_bid') }}</b-button
			>
		</div>
	</li>
</template>
<script>
import moment from 'moment'
import Vue from 'vue'
import api from '../../api'

const PublicAuctionListItem = Vue.component('public-auction-list-item', {
	props: {
		auction: Object,
	},

	data() {
		return {
			lockTime: undefined,
			viewImage: 0,
		}
	},

	endDateTimer: null,

	computed: {
		networkTimeDiff() {
			return this.$store.state.config.networkTimeDiff
		},

		colorClass() {
			if (this.auction.type === 'LOWEST_UNIQUE') return 'auction-theme-blue'
			else if (this.auction.maxPrice > 0) return 'auction-theme-max-red'
			else if (this.auction.mtsCustomerCategory) return 'auction-theme-mts'
			else return 'auction-theme-default'
		},
	},

	methods: {
		btnSfx() {
			this.$store.dispatch('sound/sfx', 'Button')
		},

		isAfterNow(time) {
			return time != undefined && moment.utc(time).isAfter(moment.utc() + this.networkTimeDiff)
		},

		clearTimers() {
			if (this.endDateTimer != null) {
				clearInterval(this.endDateTimer)
				this.endDateTimer = null
			}
		},

		onPublicAuctionClick() {
			this.$root.$emit('onPublicAuctionClick', { ...this.auction })
		},

		openMaxPriceInfoPopup() {
			this.$bvModal
				.msgBoxOk(this.$t('home.auction_max_price_info_popup_text'), {
					title: this.$t('home.auction_max_price_info_popup_title'),
					size: 'sm',
					buttonSize: 'lg',
					okTitle: this.$t('base.btn_ok'),
					modalClass: 'confirmModal',
					hideHeaderClose: false,
					centered: true,
				})
				.then((value) => {
					this.$store.dispatch('sound/sfx', 'Button')
				})
		},

		formatTime(time) {
			if (time < 0) time = 0 // fix negative
			let t = moment.duration(moment.utc(time).diff(moment.utc() + this.networkTimeDiff))

			if (t.asDays() > 1) return t.days() + 'd' + (t.hours() > 0 ? ' ' + this.pad2(t.hours()) + 'h' : '')
			else if (t.hours() > 0) return this.pad2(t.hours()) + ':' + this.pad2(t.minutes()) + 'h'
			else if (t.minutes() > 0) return this.pad2(t.minutes()) + ':' + this.pad2(t.seconds()) + 'm'

			return '00:' + this.pad2(t.seconds()) + 's'
		},

		pad2(number) {
			if (number < 0) number = 0
			return (number < 10 ? '0' : '') + number
		},

		setTimer() {
			const $this = this
			let time = undefined

			this.clearTimers()
			if (!this.auction) return

			// for test only
			// this.auction.endDateTime = "2022-09-08T10:17";

			time = moment.utc(this.auction.status === 'PENDING' ? this.auction.startDateTime : this.auction.endDateTime)

			if (this.isAfterNow(time)) {
				this.lockTime = this.formatTime(time)

				// run timer if limit expiry in one hour
				if (
					moment
						.utc(moment.utc() + $this.networkTimeDiff)
						.subtract(1, 'hours')
						.isBefore(time)
				)
					this.endDateTimer = setInterval(() => {
						let nt = moment.utc() + $this.networkTimeDiff
						if (moment.utc(nt).isBefore(time)) $this.lockTime = $this.formatTime(time)
						else {
							$this.lockTime = ''
							$this.clearTimers()
						}
					}, 1000)
			}
		},
	},

	beforeDestroy() {
		this.clearTimers()
	},

	mounted() {
		this.setTimer()
	},

	watch: {
		auction() {
			this.setTimer()
		},
	},
})

export default PublicAuctionListItem
</script>
